<template>
  <div id="posInvoices">
    <PageTitle :title="$t('pos.pos_invoices.pos_invoices')" :subtitle="$t('pos.pos_invoices.pos_invoices_description')">
    </PageTitle>
    <div class="container">
      <Datatable class="datatable" :entity="entity" :parameters="parameters" :onRowClick="onRowClick" :maps="maps"></Datatable>
    </div>
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import PageTitle from "@/components/PageTitle.vue";

  export default {
    components: { Datatable, PageTitle },
    data() {
      return {
        entity: "invoice",
        parameters: {
          company: this.$route.query.company,
          service: "pos"
        },
        maps: [
          null,
          null,
          platform => this.$t("platform." + platform),
          orderType => this.$t("pos_method." + orderType),
          null,
          status => status ? this.$t("sale_status." + status) : status
        ]
      };
    },
    methods: {
      async onRowClick(row) {
        this.$router.push(this.$router.buildContext("/pos-invoices/" + row.invoiceNumber));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #posInvoices {
    display: flex;
    flex-direction: column;

    .datatable {
      flex-grow: 1;
    }
  }
</style>